import { GlobalEnumerationsAceMittelabruf } from "@/api/model-index";
import { StammdatenService } from "@/core/services/stammdaten.service";
import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, createUrlTreeFromSnapshot } from "@angular/router";

@Injectable({
    providedIn: 'root'
})
export class FundingAmountGuard  {
    constructor(protected readonly router: Router, protected readonly stammdatenService: StammdatenService) {
    }

    async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        const portalkonfiguration = await this.stammdatenService.GetPortalKonfiguration().toPromise();

        switch (portalkonfiguration && portalkonfiguration.artDesMittelabrufs) {
            case GlobalEnumerationsAceMittelabruf.Zahlung:
                this.router.navigateByUrl(createUrlTreeFromSnapshot(route, ["../payment"]));
                return true;
            case GlobalEnumerationsAceMittelabruf.Forderbetrag:
                return true;
        }
        this.router.navigate(["/"]);
        return true;
    }
}